const stdmInitializedBuilders = new WeakSet();
function initializeStdmBuilder(root) {
  if (stdmInitializedBuilders.has(root)) return;
  stdmInitializedBuilders.add(root);
  const form = root.closest('form');
  const isSignature = root.dataset.stdmSignature === 'true';
  const logoFile = root.querySelector('[data-stdm-logo-file]');
  if (logoFile) {
    form.setAttribute('enctype','multipart/form-data');
    form.addEventListener('submit', async event => {
      if (!logoFile.files.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('[type="submit"]');
      const error = root.querySelector('[data-stdm-upload-error]');
      error.hidden = true;
      if (button) button.disabled = true;
      try {
        updateTeamQuantity();
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method:'POST', body:new FormData(form), headers:{Accept:'application/json'} });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The logo could not be added. Please try again.');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (failure) {
        error.textContent = failure.message;
        error.hidden = false;
        if (button) button.disabled = false;
      }
    }, true);
  }
  const construction = root.querySelector('[data-stdm-construction]');
  [...construction.options].forEach(option => { option.disabled = false; });
  const sides = root.querySelector('[data-stdm-sides]');
  const victoryNote = root.querySelector('[data-stdm-victory-note]');
  const constructionIndex = root.dataset.constructionIndex;
  const sizeIndex = root.dataset.sizeIndex;
  const nativeConstruction = () => [...form.querySelectorAll('input[name="option-' + constructionIndex + '"]')];
  function syncNativeConstruction() {
    const size = [...form.querySelectorAll('input[name="option-' + sizeIndex + '"]')].find(input => /50.*60/.test(input.value));
    if (size && !size.checked) { size.checked = true; size.dispatchEvent(new Event('change', {bubbles:true})); }
    const input = nativeConstruction().find(input => input.value === (construction.value === 'Victory Team' ? 'Victory' : construction.value));
    if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles:true})); }
  }
  const selectedConstruction = nativeConstruction().find(input => input.checked)?.value;
  const requestedConstruction = new URLSearchParams(location.search).get('construction');
  if (['Victory', 'Victory Team', 'All Star', 'Legends'].includes(requestedConstruction || selectedConstruction)) construction.value = requestedConstruction || selectedConstruction;
  const teamOrder = root.querySelector('[data-stdm-team-order]');
  const teamQuantity = root.querySelector('[data-stdm-team-quantity]');
  let wasTeam = false;
  const money = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
  function setOrderQuantity(quantity) {
    form.querySelectorAll('[data-stdm-native-quantity],input[name="quantity-js"],input[name="quantity"]').forEach(input => {
      input.value = String(quantity);
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  function updateTeamQuantity() {
    const minimum = construction.value === 'Victory Team' ? 7 : 1;
    const quantity = Math.max(minimum,Math.floor(Number(teamQuantity.value) || minimum));
    const unitCents = construction.value === 'All Star' ? 7295 : construction.value === 'Legends' ? 10500 : quantity >= 7 ? 3495 : 5295;
    teamQuantity.min = String(minimum);
    teamQuantity.value = String(quantity);
    root.querySelector('[data-stdm-team-total]').textContent = money.format(quantity * unitCents / 100);
    root.querySelector('[data-stdm-team-equation]').textContent = quantity + ' × ' + money.format(unitCents / 100);
    root.querySelector('[data-stdm-quantity-minus]').disabled = quantity <= minimum;
    setOrderQuantity(quantity);
  }
  root.querySelector('[data-stdm-quantity-minus]').addEventListener('click',()=>{teamQuantity.value=String(Number(teamQuantity.value)-1);updateTeamQuantity();});
  root.querySelector('[data-stdm-quantity-plus]').addEventListener('click',()=>{teamQuantity.value=String(Number(teamQuantity.value)+1);updateTeamQuantity();});
  teamQuantity.addEventListener('change',updateTeamQuantity);
  teamQuantity.addEventListener('blur',updateTeamQuantity);
  teamQuantity.addEventListener('input',()=>{if(Number.isInteger(Number(teamQuantity.value)) && Number(teamQuantity.value)>=1)updateTeamQuantity();});
  form.addEventListener('submit',()=>{updateTeamQuantity();},true);
  const designFields = [...root.querySelectorAll('[data-stdm-design]')];
  function update() {
    const isTeam = construction.value === 'Victory Team';
    teamOrder.hidden = false;
    teamOrder.querySelectorAll('[data-stdm-team-only]').forEach(element=>{element.hidden=!isTeam || isSignature;});
    teamOrder.querySelector('textarea').disabled = !isTeam || isSignature;
    if (wasTeam && !isTeam) teamQuantity.value = '1';
    updateTeamQuantity();
    wasTeam = isTeam;
    const doubleSided = !['Victory', 'Victory Team'].includes(construction.value);
    root.dataset.doubleSided = String(doubleSided);
    const signatureNotes = root.querySelector('[data-stdm-signature-personalization]');
    if (signatureNotes) { signatureNotes.hidden = doubleSided; signatureNotes.querySelector('textarea').disabled = doubleSided; }
    syncPersonalization();
    sides.hidden = !doubleSided;
    victoryNote.hidden = doubleSided;
    sides.querySelectorAll('select, textarea, input').forEach(field => { field.disabled = !doubleSided; });

    designFields.forEach(select => {
      const preview = root.querySelector('[data-stdm-preview="' + select.dataset.stdmDesign + '"]');
      const image = select.selectedOptions[0]?.dataset.image;
      preview.hidden = !image || !doubleSided;
      if (image) { preview.src = image; preview.alt = select.value; }
    });

  }
  root.querySelectorAll('[data-stdm-search]').forEach(search => {
    const side = search.dataset.stdmSearch;
    const select = root.querySelector('[data-stdm-design="' + side + '"]');
    const results = root.querySelector('[data-stdm-results="' + side + '"]');
    search.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      results.replaceChildren();
      results.hidden = !query;
      search.setAttribute('aria-expanded', String(Boolean(query)));
      if (!query) return;
      const matches = [...select.options].filter(option => option.textContent.toLowerCase().includes(query));
      if (!matches.length) {
        const message = document.createElement('p');
        message.textContent = results.dataset.empty;
        results.append(message);
      }
      matches.forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = option.textContent;
        button.addEventListener('click', () => {
          select.value = option.value;
          search.value = '';
          results.hidden = true;
          search.setAttribute('aria-expanded', 'false');
          update();
        });
        results.append(button);
      });
    });
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') { results.hidden = true; search.setAttribute('aria-expanded', 'false'); }
      if (event.key === 'Enter') { event.preventDefault(); results.querySelector('button')?.focus(); }
    });
    select.addEventListener('change', () => { search.value = ''; results.hidden = true; search.setAttribute('aria-expanded', 'false'); });
  });
  root.addEventListener('change', event => { if (event.target === construction) syncNativeConstruction(); update(); });
  root.addEventListener('input', event => { if (event.target.matches('textarea')) update(); });
  function syncPersonalization() {
    const doubleSided = !['Victory','Victory Team'].includes(construction.value);
    form.querySelectorAll('.gpo-app .gpo-element').forEach(element=>{
      const fields = [...element.querySelectorAll('input[data-field-name],textarea[data-field-name]')].filter(field=>field.type!=='file');
      if (!fields.length || element.querySelector('input[type="file"]')) return;
      element.hidden = doubleSided;
      fields.forEach(field=>{
        if (!field.hasAttribute('data-stdm-original-required')) field.dataset.stdmOriginalRequired=String(field.required);
        if (doubleSided && field.type !== 'radio' && field.type !== 'checkbox' && field.value !== 'See front and back personalization details') {
          field.dataset.stdmSingleValue=field.value;
          field.value='See front and back personalization details';
          field.dispatchEvent(new Event('input',{bubbles:true}));
          field.dispatchEvent(new Event('change',{bubbles:true}));
        }
        if (!doubleSided && field.value==='See front and back personalization details') {
          field.value=field.dataset.stdmSingleValue || '';
          field.dispatchEvent(new Event('input',{bubbles:true}));
          field.dispatchEvent(new Event('change',{bubbles:true}));
        }
        field.disabled=doubleSided;
        field.required=!doubleSided && field.dataset.stdmOriginalRequired==='true';
      });
    });
    const patterns = {name:new RegExp('^(athlete name|twin name 1)$','i'),number:new RegExp('^(athlete )?number$','i'),team:new RegExp('^(team(/organization| name/studio name)?|studio)$','i'),color:new RegExp('^custom color request$','i')};
    root.querySelectorAll('[data-stdm-fallback]').forEach(group => {
      const kind = group.dataset.stdmFallback;
      const matching = [...form.querySelectorAll('.gpo-app input,.gpo-app textarea')].find(field => {
        const label = (field.closest('.gpo-element')?.querySelector('label')?.textContent || field.getAttribute('data-field-name') || '').replaceAll('*','').trim();
        return patterns[kind].test(label.trim());
      });
      group.hidden = doubleSided || Boolean(matching);
      group.querySelector('input').disabled = doubleSided || Boolean(matching);
    });
  }
  if (isSignature) form.querySelectorAll('.gpo-app .gpo-element').forEach(element => { if (element.querySelector('input[type="file"]')) { const label=element.querySelector('label'); if(label) label.textContent='Upload a logo (optional)'; } });
  syncPersonalization();
  new MutationObserver(syncPersonalization).observe(form,{childList:true,subtree:true});
  syncNativeConstruction();
  update();
}
function initializeStdmBuilders() { document.querySelectorAll('[data-stdm-builder]').forEach(initializeStdmBuilder); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeStdmBuilders); else initializeStdmBuilders();
document.addEventListener('shopify:section:load', initializeStdmBuilders);
new MutationObserver(initializeStdmBuilders).observe(document.documentElement, {childList:true,subtree:true});

